import { AdvancedTooltip, Text } from 'common-components'
import { AiImageGenerateOption } from '../styled'
import { memo, useCallback, useMemo, useRef, useState } from 'react'
import { useDropdownState } from 'hooks/useDropdownState'
import { useMobileInnerSliderCallbacks } from 'hooks/useMobileInnerSliderCallbacks'
import { NOT_SELECTED_STYLE, NOT_SELECTED_STYLE_ID } from './consts'
import { IImageStyle } from './types'
import AiImageStylesToggler from './Toggler'
import AiImageStylesFlyout from './FlyOut'

import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IAiImageStylesState } from 'store/types/aiImage'

interface IProps {
  disabled?: boolean
  onSetStyleId: (id: number | undefined) => void
  styleId: number | string | undefined
  styles: IAiImageStylesState
  disableFieldLabel?: boolean
  placeholderText?: T
}
const AiImageStyles: React.FC<IProps> = ({
  disabled,
  onSetStyleId,
  styleId,
  styles,
  disableFieldLabel,
  placeholderText = T.STYLES_LABEL
}) => {
  const anchorRef = useRef<HTMLDivElement | null>(null)
  const [buttonRef, setButtonRef] = useState<HTMLDivElement | null>(null)

  const { openCallback, closeCallback } = useMobileInnerSliderCallbacks()
  const { isOpen, toggleDropdown, closeDropdown } = useDropdownState(
    openCallback,
    closeCallback
  )
  const targetStyleId = styleId || NOT_SELECTED_STYLE_ID

  const activeStyle = useMemo(
    () =>
      styles?.data?.find((item: IImageStyle) => item.id === targetStyleId) ||
      NOT_SELECTED_STYLE,
    [styles, targetStyleId]
  )

  const handleStyleClick = useCallback(
    (id: string | number) => {
      if (styleId !== id) {
        const selectedStyleId = id === NOT_SELECTED_STYLE_ID ? undefined : id

        onSetStyleId?.(selectedStyleId as number)
      }
    },
    [styleId, onSetStyleId]
  )

  return (
    <>
      <AiImageGenerateOption
        ref={anchorRef}
        onClick={disabled ? undefined : toggleDropdown}
        $disabled={disabled}
      >
        {!disableFieldLabel ? (
          <Text type="subtitle" color="secondaryDark">
            {translate(T.STYLES_LABEL)}
          </Text>
        ) : null}
        <AiImageStylesToggler
          isOpen={isOpen}
          style={activeStyle}
          disabled={disabled}
          setButtonRef={setButtonRef}
          label={placeholderText}
        />

        {disabled && (
          <AdvancedTooltip
            tooltipText={translate(T.ADD_REF_IMAGE_TO_CHOOSE_STYLE_TOOLTIP)}
            btnRef={{ current: buttonRef }}
            showMobileTooltip
            isToggledByClick={false}
            maxWidth={400}
          />
        )}
      </AiImageGenerateOption>
      {isOpen && (
        <AiImageStylesFlyout
          isOpen={isOpen}
          onClose={closeDropdown}
          anchorRef={anchorRef}
          selectedStyleId={targetStyleId}
          onStyleClick={handleStyleClick}
          styles={styles}
        />
      )}
    </>
  )
}

export default memo(AiImageStyles)
